	<!--begin::Footer-->
  <div class="footer py-4">
    <!--begin::Container-->
    <div class="container align-items-center" [ngClass]="{'justify-content-between': industryAffiliations.length}">
      <!--begin::Copyright-->
      <div class="text-dark order-2 order-md-1 d-flex flex-stack">
        <div class="d-flex">
          <span class="text-muted fw-bold me-1">{{currentYear}}©</span>
          <a href="https://www.lodasoft.com" height="24" target="_blank" class="text-gray-800 text-hover-primary">Lodasoft</a>
          <ng-container *transloco="let t">
            <a [href]="legalDocumentsHref" height="24" target="_blank" class="text-gray-800 text-hover-primary ms-4">{{ t('wizard.createAccount.privacyPolicyTitle') }}</a>
            <a [href]="legalDocumentsHref" height="24" target="_blank" class="text-gray-800 text-hover-primary ms-4">{{ t('wizard.createAccount.termsOfServiceTitle') }}</a>
          </ng-container>
          @if (version) {
            <span class="text-muted ms-4" title="Build Version">v{{version}}</span>
          }
        </div>
        @if (industryAffiliations.length) {
          <div class="industry-affiliations-container">
            @for (aff of industryAffiliations; track aff) {
              @if (aff == 'Fdic') {
                <img src="/assets/images/industry-affiliations/fdic.png" class="mx-2" height="56" alt="logo" />
              }
              @if (aff == 'Ehl') {
                <img src="/assets/images/industry-affiliations/ehl.jpg" class="mx-2" height="56" alt="logo" />
              }
              @if (aff == 'Eho') {
                <img src="/assets/images/industry-affiliations/eho.jpg" class="mx-2" height="56" alt="logo" />
              }
              @if (aff == 'Ncua') {
                <img src="/assets/images/industry-affiliations/ncua.jpg" class="mx-2" height="56" alt="logo" />
              }
              @if (aff == 'Mba') {
                <img src="/assets/images/industry-affiliations/mba.jpg" class="mx-2" height="56" alt="logo" />
              }
            }
          </div>
        }
        <!-- <span *ngIf="isDefaultFlow">Using Default Flow</span> -->
      </div>
      <!--end::Copyright-->
      <!--begin::Menu-->
      <!-- <ul class="menu menu-gray-600 menu-hover-primary fw-bold order-1">
        <li class="menu-item">
          <a href="https://lodasoft.com/faqs" target="_blank" class="menu-link px-2">About</a>
        </li>
        <li class="menu-item">
          <a href="https://lodasoft.com/support" target="_blank" class="menu-link px-2">Support</a>
        </li>
        <li class="menu-item">
          <a href="https://lodasoft.com" target="_blank" class="menu-link px-2">Purchase</a>
        </li>
      </ul> -->
      <!--end::Menu-->
    </div>
    <!--end::Container-->
    @if (footerDisclosureHtml$ | async; as disclosure) {
      <div class="container mt-2">
        <div class="footer-disclosure-content text-muted" [innerHTML]="disclosure"></div>
      </div>
    }
  </div>
  <!--end::Footer-->
